import { render } from "./ActivityInvitationEmail.vue?vue&type=template&id=65c12d88&scoped=true"
import script from "./ActivityInvitationEmail.vue?vue&type=script&lang=js"
export * from "./ActivityInvitationEmail.vue?vue&type=script&lang=js"

import "./ActivityInvitationEmail.vue?vue&type=style&index=0&id=65c12d88&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c12d88"]])

export default __exports__